module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Air-ballon-6b2a8f7eeb5056d3b79c959de70ab92f.svg";